import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "confirmationForm",
  class: "form"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "divider divider_green mb-30" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  id: "actionInput"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "action-buttons sm-pdr-0 sm-pdl-0"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_Textarea, {
      label: "Comment",
      palceholder: "Type a comment",
      modelValue: _ctx.comment,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
      readonly: _ctx.status != 1,
      max: 1000,
      error: _ctx.error,
      isRequired: true
    }, null, 8, ["modelValue", "readonly", "error"]),
    (_ctx.status === '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-secondary",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleReview('Reject')), ["prevent"])),
            disabled: _ctx.loadingReview
          }, " Reject ", 8, _hoisted_5),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: _ctx.approveButton.Disabled || _ctx.loadingReview,
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleReview('Approve')), ["prevent"]))
          }, _toDisplayString(_ctx.approveButton.Value), 9, _hoisted_6)
        ]))
      : _createCommentVNode("", true)
  ]))
}